import React from 'react';

import './NavigationBar.scss';
import NavigationItem from './NavigationItem';
import I18N from '../../I18N';
import {
  SITES_ROUTE,
  TEAMS_ROUTE,
  COACHES_ROUTE,
  ATHLETES_ROUTE,
  VIDEOS_ROUTE
} from '../../utils/constants';

const NavigationItems = [
  { title: I18N.t("SITES"), path: SITES_ROUTE },
  { title: I18N.t("TEAMS"), path: TEAMS_ROUTE },
  { title: I18N.t("COACHES"), path: COACHES_ROUTE },
  { title: I18N.t("ATHLETES"), path: ATHLETES_ROUTE },
  { title: I18N.t("VIDEOS"), path: VIDEOS_ROUTE },
]
const NavigationBar = ()=> {

  return (
    <div className="navigation-bar" data-testid="navigation-bar">
      {NavigationItems.map(item => 
        <NavigationItem 
          key={item.title} 
          item={item} 
        />)}
    </div>
  );
};

export default NavigationBar;

